module.exports = __webpack_public_path__ + "static/media/indiqueopan.c6fc2deb.png";